import { FieldError } from "react-hook-form";
import { clsx } from 'clsx'

interface Props {
	error?: FieldError;
	className?: string;
}
export default function ValidateError(props: Props) {
	if (!props.error) return null;

	return <p className={clsx('mt-2.5 verify-text', props.className)}>{props.error.message}</p>;
}
